module.exports = __webpack_public_path__ + "img/advantage-standard-setting.99b79eb4.png";